import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { VideoWidget } from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'
import { GbSafePipe } from 'libs/shared/utils/pipes/src/lib/gb-safe-pipe/gb-safe.pipe'
import { GbPresenterWidgetPlaceholderComponent } from '../gb-presenter-widget-placeholder/gb-presenter-widget-placeholder.component'

@Component({
  selector: 'gb-presenter-widget-video',
  imports: [CommonModule, TranslateModule, GbPresenterWidgetPlaceholderComponent, GbSafePipe],
  templateUrl: './gb-presenter-widget-video.component.html',
  styleUrl: './gb-presenter-widget-video.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterWidgetVideoComponent {
  @Input({ required: true }) videoWidget!: VideoWidget
  @Input() draggable = true

  get safeEmbedUrl(): string {
    const url = (this.videoWidget?.video_url || '').trim()
    if (!url) return ''

    try {
      const parsed = new URL(url)
      if (parsed.protocol !== 'https:') return ''

      if (isAllowedVideoEmbedUrl(parsed)) {
        return parsed.toString()
      }

      return ''
    } catch {
      return ''
    }
  }
}

function isAllowedVideoEmbedUrl(url: URL): boolean {
  const hostname = url.hostname

  const isYouTube =
    hostname === 'youtube.com' ||
    hostname === 'www.youtube.com' ||
    hostname === 'youtube-nocookie.com' ||
    hostname === 'www.youtube-nocookie.com'

  if (isYouTube) {
    return url.pathname.startsWith('/embed/')
  }

  const isVimeo = hostname === 'player.vimeo.com'
  if (isVimeo) {
    return url.pathname.startsWith('/video/')
  }

  return false
}
